import { useState } from 'preact/hooks';
import { isYes } from '@util/common.js';
import CustomizeFullProgressBar from './customize-full-progress-bar.jsx';
import Description from '@components/overlays/shared/description.jsx';
import { deepSignal } from 'deepsignal';
import { CHARITY } from '@util/const.js';
import ScaledOverlayWrapper from '@components/overlays/wrapper/scaled-overlay-wrapper.jsx';
import Picker from '@components/input/picker.input.jsx';
import {
  MaxProgressBar,
  toMaxProgressBarTextColor,
} from '@playlive/overlay-core/progress-bars/max';
import { toColor } from '@playlive/overlay-core/colors';
import DemoAnimationsDropdown from '@components/overlays/shared/demo-animations-dropdown.jsx';
import usePreviewAnimations from '@hooks/usePreviewAnimations.js';
import useCommon from '@hooks/useCommon.js';
import useDemoProgressBarData from '@hooks/useDemoProgressBarData.js';

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  classicDonorOptions: 'yes',
  textColor: 'light-aqua',
  bgColor: 'default-red',
  showChallenges: 'yes',
  showRewards: 'yes',
  showDonors: 'yes',
  showScroller: 'yes',
  scrollerPosition: 'bottom',
  donationTimeOffset: 1,
  showAllDonations: 'no',
});

export default function MaxProgressBarPage() {
  const { overlayURL, setConfigState, overlayInfo } = useCommon({ config });
  const [showMilestones, setMilestones] = useState(false);
  const [currentAmount, setCurrentAmount] = useState(750);
  const scrollPositions = [
    { name: 'Top', value: 'top' },
    { name: 'Bottom', value: 'bottom' },
  ];

  const { demoDonations, demoMilestones, demoTargets, demoRewards } =
    useDemoProgressBarData(config);

  const { isPreviewingAnimation, startAnimation } = usePreviewAnimations({
    setMilestones,
    setCurrentAmount,
  });

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col items-center justify-center  overflow-x-hidden">
        <div className="example_overlay relative select-none w-full">
          <ScaledOverlayWrapper
            addPadding={false}
            defaultScale={'scale-100'}
            allowScaling={false}
            addPosition={'absolute top-0'}
            innerClassName={'h-[220px]'}
          >
            <div className="absolute top-0 z-10 max-w-full w-full">
              <MaxProgressBar
                className="shadow-2xl"
                currentAmount={currentAmount}
                goalAmount={1000}
                backgroundColor={toColor(config.bgColor)}
                textColor={toMaxProgressBarTextColor(config.textColor)}
                showScroller={isYes(config.showScroller)}
                showMilestones={showMilestones}
                showDonors={isYes(config.showDonors)}
                showChallenges={isYes(config.showChallenges)}
                showRewards={isYes(config.showRewards)}
                scrollerPosition={config.scrollerPosition}
                rewards={demoRewards}
                donations={demoDonations}
                targets={demoTargets}
                milestones={demoMilestones}
                demoShowMilestones={showMilestones}
              />
            </div>
          </ScaledOverlayWrapper>
          <DemoAnimationsDropdown
            onChosen={startAnimation}
            disabled={isPreviewingAnimation}
          />
        </div>

        <Description>
          <p className="pb-4">
            Utilize our dynamic Max overlay to enhance your Tiltify fundraising
            campaign. This overlay stretches the full width of your stream,
            tracks your progress and recognizes donors.
          </p>
        </Description>

        <CustomizeFullProgressBar
          config={config}
          setConfigState={setConfigState}
          overlayURL={overlayURL}
          setMilestones={setMilestones}
          setCurrentAmount={setCurrentAmount}
          overlayName={overlayInfo.name}
          obsDimensions={overlayInfo.obsDimensions}
          childrenSlot="scroller"
        >
          <Picker
            label="Position"
            items={scrollPositions}
            onChange={setConfigState}
            currentValue={config.scrollerPosition}
            fieldName="scrollerPosition"
          />
        </CustomizeFullProgressBar>
      </div>
    </div>
  );
}
